export enum AccessManagementUserType {
  USER = 'USER',
  GROUP = 'GROUP',
}
